import { Check } from 'lucide-react';

export default function EditRoleFooter({
  rolesChanged,
  regionsChanged,
  submitting,
  canSave,
  onCancel,
  onSave,
}: {
  rolesChanged: boolean;
  regionsChanged: boolean;
  submitting: boolean;
  canSave: boolean;
  onCancel: () => void;
  onSave: () => void;
}) {
  const changes: string[] = [];
  if (rolesChanged) changes.push('role');
  if (regionsChanged) changes.push('region');
  const summary =
    changes.length === 0
      ? 'No changes yet'
      : `Audit will log ${changes.join(' + ')} change${changes.length > 1 ? 's' : ''}`;

  return (
    <div className="px-[22px] py-3.5 border-t border-stone-200 dark:border-stone-800 bg-stone-50 dark:bg-[#1e2520] flex items-center gap-2.5">
      <div className="flex-1 text-[11px] text-stone-500 dark:text-stone-400 leading-snug">
        {summary}
      </div>
      <button
        type="button"
        onClick={onCancel}
        disabled={submitting}
        className="h-8 px-3.5 rounded-lg text-[13px] font-semibold text-stone-600 dark:text-stone-400 hover:bg-stone-100 dark:hover:bg-[#242d28] disabled:opacity-50"
      >
        Cancel
      </button>
      <button
        type="button"
        onClick={onSave}
        disabled={!canSave}
        className="inline-flex items-center gap-1.5 h-8 px-3.5 rounded-lg text-[13px] font-semibold text-white bg-moss-600 hover:bg-moss-700 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        <Check size={13} />
        {submitting ? 'Saving…' : 'Save changes'}
      </button>
    </div>
  );
}
